import classnames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultLinks = [{
  name: 'Terms of Use',
  url: 'https://docs.console.zenlayer.com/zenlayer-legal/zenlayer-terms-of-use'
}, {
  name: 'Privacy Notice',
  url: 'https://docs.console.zenlayer.com/zenlayer-legal/zenlayer-privacy-policy'
}, {
  name: 'Cookie Notice',
  url: 'https://docs.console.zenlayer.com/zenlayer-legal/zenlayer-cookie-policy'
}];
const Footer = props => {
  const {
    links = defaultLinks,
    company = 'Zenlayer',
    extra,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout-footer");
  return /*#__PURE__*/_jsxs("footer", {
    className: classnames(baseClassName, className),
    style: style,
    children: [links.map(link => /*#__PURE__*/_jsx("a", {
      href: link.url,
      target: "_blank",
      className: "".concat(baseClassName, "-item"),
      children: link.name
    }, link.url)), /*#__PURE__*/_jsxs("span", {
      className: "".concat(baseClassName, "-item"),
      children: ["Copyright \xA9 ", new Date().getFullYear(), " ", company]
    }), extra]
  });
};
export default Footer;